/**
 * Returns a callback to update the filter summary based on checked inputs.
 * @param {Element} filter
 * @param {Element|jQuery} itemTemplate
 * @param {boolean} showOptionName
 * @returns {Function} A callback function
 */
const handleSummaryUpdate = (filter, itemTemplate, showOptionName = false) => () => {
    const $selected = $.unique($(filter).find('input:checked').closest('.select'));
    const items = Array.from($selected)
        // collect id and label from select component
        .map(select => ({
            id: select.name,
            label: $(select).attr('data-placeholder'),
            optionName: showOptionName ? $(select).find('input:checked').attr('name') : '',
        }))
        // map data to cloned item template
        .map(data => (
            $(itemTemplate)
                .clone()
                .text(`${showOptionName ? data.optionName : data.label}`)
                .attr('data-id', data.id)
                .get(0)
        ));

    // update DOM
    const $summary = $(filter).find('.filter__summary__list');
    $summary.children().remove();
    $summary.append(items);
};

export default handleSummaryUpdate;



// WEBPACK FOOTER //
// ./src/scripts/components/filter/handleSummaryUpdate.js